
class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (event) => {
      if (event.code === 'Escape') this.close();
    });

    this.bindOverlay();
    this.setHeaderCartIconAccessibility();
  }

  bindOverlay() {
    const overlay = this.querySelector('#CartDrawer-Overlay');

    if (!overlay || overlay.dataset.ptpCloseBound === 'true') {
      return;
    }

    overlay.dataset.ptpCloseBound = 'true';
    overlay.addEventListener('click', () => this.close());
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');

    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });

    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) {
      this.setActiveElement(triggeredBy);
    }

    const cartDrawerNote = this.querySelector(
      '[id^="Details-"] summary'
    );

    if (
      cartDrawerNote &&
      !cartDrawerNote.hasAttribute('role')
    ) {
      this.setSummaryAccessibility(cartDrawerNote);
    }

    this.bindOverlay();

    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    const applyFocus = () => {
      if (!this.classList.contains('active')) return;

      const isEmpty = this.classList.contains('is-empty');

      const focusContainer = isEmpty
        ? this.querySelector('.drawer__inner-empty')
        : this.querySelector('.drawer__inner');

      if (!focusContainer) return;

      const focusTarget = isEmpty
        ? focusContainer.querySelector(
            '.drawer__close, a, button'
          )
        : focusContainer.querySelector(
            '.drawer__close'
          );

      if (
        typeof trapFocus === 'function' &&
        focusTarget
      ) {
        trapFocus(focusContainer, focusTarget);
      } else if (
        typeof focusContainer.focus === 'function'
      ) {
        focusContainer.focus();
      }
    };

    this.addEventListener(
      'transitionend',
      (event) => {
        if (event.target !== this) return;
        applyFocus();
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');

    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(this.activeElement);
    }

    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (
      cartDrawerNote.nextElementSibling &&
      cartDrawerNote.nextElementSibling.id
    ) {
      cartDrawerNote.setAttribute(
        'aria-controls',
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute(
        'aria-expanded',
        !event.currentTarget.closest('details').hasAttribute('open')
      );
    });

    cartDrawerNote.parentElement.addEventListener(
      'keyup',
      onKeyUpEscape
    );
  }

  renderContents(parsedState) {
    if (!parsedState || !parsedState.sections) {
      console.error(
        'Cart drawer: missing updated cart sections.',
        parsedState
      );
      return;
    }

    this.productId = parsedState.id;

    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      const sectionHTML = parsedState.sections[section.id];

      if (!sectionElement || !sectionHTML) return;

      const newHTML = this.getSectionInnerHTML(
        sectionHTML,
        section.selector
      );

      if (newHTML !== null) {
        sectionElement.innerHTML = newHTML;
      }
    });

    /*
     * IMPORTANT:
     * Shopify has now returned the updated cart HTML.
     * Synchronise the outer drawer's empty state with
     * the newly rendered contents.
     */

    const hasCartItems = Boolean(
      this.querySelector(
        '#CartDrawer-CartItems .cart-item'
      )
    );

    this.classList.toggle('is-empty', !hasCartItems);

    const inner = this.querySelector('.drawer__inner');
    const drawerItems = this.querySelector('cart-drawer-items');

    if (inner) {
      inner.classList.toggle('is-empty', !hasCartItems);
    }

    if (drawerItems) {
      drawerItems.classList.toggle('is-empty', !hasCartItems);
    }

    this.bindOverlay();

    setTimeout(() => {
      this.open();
    });
  }

  getSectionInnerHTML(
    html,
    selector = '.shopify-section'
  ) {
    if (!html) return null;

    const parsedHTML = new DOMParser().parseFromString(
      html,
      'text/html'
    );

    const element = parsedHTML.querySelector(selector);

    return element ? element.innerHTML : null;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(
    html,
    selector = '.shopify-section'
  ) {
    if (!html) return null;

    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

if (!customElements.get('cart-drawer')) {
  customElements.define('cart-drawer', CartDrawer);
}

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

if (!customElements.get('cart-drawer-items')) {
  customElements.define(
    'cart-drawer-items',
    CartDrawerItems
  );
}
